/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext, useRef, useState, useEffect } from 'react';

import { ContentBody, BodyPrincipal, BodyMenu, Spacer, CenterLoadMore } from './styled';

import ButtonMenu from '../../components/MenuButton';
import VideoCategory from '../../components/VideoCategory';
import Banner from '../../components/Banner';

import { availableContents, availableCatagories, availableVideos } from '../../services/mock';
import { CoreContext } from '../../context/CoreContext';

import {
  ReadHome,
  ReadHomeTabs,
  ReadKeepWatching,
  ReadTabCatalog,
  ReadTabPlaylist,
} from '../../services/catalog';
import { parseBanner, parseCategory, parseCollection, parseVideo } from '../../utils/parser';
import { Load } from '../../ui/styled';
import { normalizeStrapiRegister } from '../../utils';
import VideoButton from '../VideoButton';

export default function PageHome({ setFocus }: { setFocus?: (key: string) => void }) {
  const { currentProfile, authentication, side, setSide, moreCategory, setMoreCategory } =
    useContext(CoreContext);

  const [banners, setBanners] = useState<Array<Record<string, unknown>>>([]);
  const [tabs, setTabs] = useState<Array<Record<string, unknown>>>([]);
  const [loading, setLoading] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(0);
  const [categoryCollections, setCategoryCollections] = useState<Array<Record<string, unknown>>>(
    [],
  );

  const action = (item: Record<string, unknown>, key: number) => {
    if (item.id === 5) {
      setSide({ type: 'side-more', tabs });
    } else {
      setCurrentCategory(key);
    }
  };

  const sliderRef = useRef<HTMLElement>(null);

  const [categories, setCategories] = useState([availableContents[0]]);

  const initTabs = () => {
    if (tabs?.length) {
      const homeTabs = [availableContents[0], ...[...tabs].slice(0, 3).map(parseCategory)];
      if (tabs?.length > 3) {
        homeTabs.push(availableContents[1]);
      }
      setCategories(homeTabs as typeof availableContents);
    }
  };

  const init = async () => {
    const home = await ReadHome();
    const tabs = await ReadHomeTabs();

    // Dual-shape: Strapi v4 nested `data.attributes.featured`, v5 flat `data.featured`.
    const homeData = home?.data as Record<string, unknown> | undefined;
    const featured = ((homeData?.attributes as Record<string, unknown>)?.featured ??
      homeData?.featured) as Array<Record<string, unknown>> | undefined;
    if (featured?.length) {
      setBanners(featured.map(parseBanner));
    }

    if (tabs?.data?.length) {
      setTabs(
        currentProfile?.kids
          ? [...tabs?.data].filter((f) => f.attributes.name === 'Kids')
          : [...tabs?.data],
      );
    }
  };

  const showMoreCategory = async () => {
    setLoading(true);
    const result = await ReadTabCatalog(
      (moreCategory as { id?: number | string })?.id as number | string,
    );
    if (result?.data?.length) {
      setCategoryCollections(result?.data?.map(parseCollection));
    } else {
      setCategoryCollections([]);
    }
    setLoading(false);
    setMoreCategory(null);
  };

  const initCategory = async () => {
    if (!currentProfile) return;
    if (currentCategory > 0 && currentCategory < 4 && !tabs[currentCategory - 1]?.id) {
      return;
    }
    if (loading) return;
    // console.log("WH ", tabs[currentCategory-1], currentCategory)

    setLoading(true);
    const requests = [];
    if (currentCategory === 0) {
      requests.push(ReadTabPlaylist());
    }
    if (currentCategory > 0 && currentCategory < 4) {
      if (tabs[currentCategory - 1]?.id) {
        requests.push(ReadTabCatalog(tabs[currentCategory - 1]?.id as number | string));
      }
    }
    if (currentCategory === 4) {
      // showing more, nothing to do
    }
    const result = await Promise.all(requests);

    if (currentProfile?.kids) {
      result[0].data = result?.[0]?.data?.filter(
        (f: Record<string, unknown>) => (f?.attributes as Record<string, unknown>)?.name === 'Kids',
      );
    }

    if (result?.[0]?.data?.length) {
      const resultWatch =
        currentProfile?.id && authentication?.jwt
          ? await ReadKeepWatching(currentProfile?.id, authentication?.jwt)
          : { data: [] };
      // const videosWatching = (resultWatch?.data||[])?.filter(ff => !normalizeStrapiRegister(ff)?.data?.finishing)?.map(mm => parseVideo(normalizeStrapiRegister(mm)?.stream_show)||[])?.reduce((p, c) => p.map(m => m.id)?.includes(c.id) ? p : [...p, c], [])

      const videosWatching = (resultWatch?.data || [])
        ?.sort((a: Record<string, unknown>, b: Record<string, unknown>) => {
          // Strapi v5 flat records keep updatedAt at top level; v4 nested it under
          // `attributes`. Read both (with a numeric fallback) so re-watched titles
          // actually rise instead of the comparator returning NaN → server order.
          const bAttrs = b?.attributes as Record<string, unknown> | undefined;
          const aAttrs = a?.attributes as Record<string, unknown> | undefined;
          const bTime = new Date(String(b?.updatedAt ?? bAttrs?.updatedAt ?? '')).getTime() || 0;
          const aTime = new Date(String(a?.updatedAt ?? aAttrs?.updatedAt ?? '')).getTime() || 0;
          return bTime - aTime;
        })
        ?.map((mm: Record<string, unknown>) => {
          const normalRegister = normalizeStrapiRegister(mm);
          // console.log("normalRegister", normalRegister)
          if (
            !normalRegister?.stream_show ||
            !!(normalRegister?.data as Record<string, unknown>)?.finishing
          )
            return false;
          return parseVideo(normalRegister?.stream_show as Record<string, unknown>);
        })
        ?.filter((f: unknown) => f)
        ?.reduce(
          (p: Array<Record<string, unknown>>, c: Record<string, unknown>) =>
            p.map((m: Record<string, unknown>) => m.id)?.includes(c.id) ? p : [...p, c],
          [] as Array<Record<string, unknown>>,
        );

      const watched = {
        id: 2,
        image: null,
        title: 'Continuar assistindo',
        videos: videosWatching || [],
      };

      setCategoryCollections(
        watched?.videos?.length && currentCategory === 0
          ? [watched, ...result?.[0]?.data?.map(parseCollection)]
          : result?.[0]?.data?.map(parseCollection),
      );
    } else {
      setCategoryCollections([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    init();
  }, [currentProfile]);

  useEffect(() => {
    if ((moreCategory as { id?: number | string })?.id) {
      showMoreCategory();
    }
  }, [moreCategory]);

  useEffect(() => {
    initTabs();
  }, [tabs]);

  useEffect(() => {
    initCategory();
  }, [currentCategory, tabs, currentProfile]);

  const pageSize = 2;
  const [page, setPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);

  const timerMore = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const timerMoreAction = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    return () => {
      if (timerMore.current) clearTimeout(timerMore.current);
      if (timerMoreAction.current) clearTimeout(timerMoreAction.current);
    };
  }, []);

  const loadMore = () => {
    if (categoryCollections?.length >= pageSize * page) {
      clearTimeout(timerMoreAction.current);
      timerMoreAction.current = setTimeout(() => {
        clearTimeout(timerMore.current);
        setLoadingMore(true);
        timerMore.current = setTimeout(() => {
          setPage((prev) => prev + 1);
          setLoadingMore(false);
        }, 5000);
      }, 1500);
    }
  };

  return (
    <>
      <ContentBody ref={sliderRef}>
        <Banner
          banners={
            banners as unknown as {
              id: number;
              title?: string;
              description?: string;
              image?: { uri: string };
              category?: { title: string; color: string };
            }[]
          }
        />
        <BodyPrincipal>
          {loading ? (
            <>
              <Spacer />
              <Load />
            </>
          ) : (
            <>
              <BodyMenu>
                {categories.map((item, key) => (
                  <ButtonMenu
                    key={key}
                    item={item}
                    onPress={() => action(item, key)}
                    onEnterPress={() => action(item, key)}
                  />
                ))}
              </BodyMenu>
              {categoryCollections?.slice(0, page * pageSize)?.map((item, key) => (
                <VideoCategory
                  key={key}
                  item={item}
                  availableVideos={item.videos as Record<string, unknown>[]}
                  availableCatagories={categoryCollections}
                  verticalRef={sliderRef}
                  verticalSize={page * pageSize}
                  verticalLoadMore={loadMore}
                  verticalKey={key}
                />
              ))}
            </>
          )}

          {loadingMore ? (
            <CenterLoadMore>
              <VideoButton loading />
            </CenterLoadMore>
          ) : null}
        </BodyPrincipal>
      </ContentBody>
    </>
  );
}
